module.exports = __webpack_public_path__ + "assets/img/key-success-story.e9d1aba1.jpg";